// put here all the assets that have static URIs
export const CAR_NOT_FOUND_THUMB = 'assets/image_car_not_found.svg'
export const WELCOME_LOGO_ASOFIX = 'assets/welcome_logo_asofix.jpg'
export const WELCOME_EMAIL_FOOTER = 'assets/welcome_email_footer.jpg'
export const CONFIRMAR_USUARIO_FOOTER = 'assets/confirmar_usuario_footer.jpg'
export const AVATAR_PLACEHOLDER = 'assets/undraw_profile_pic_ic5t.svg'
export const ICONO_VARITA = 'icons/Vara%20m%C3%A1gica.svg'
